import CustomButton from "components/CustomButton";
import CustomInput from "components/CustomInput/CustomInput";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom";
import SurveyService from "services/SurveyService";
import * as Yup from "yup";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useToasts } from "react-toast-notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const surveySchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required."),
});

export default ({ onClose, reload, isCreating, dispatch, teamSurveys }) => {
  const params = useParams();
  const { addToast } = useToasts();
  const [isPublishing, setIsPublishing] = useState(false);

  const submitForm = async (data, publish = false) => {
    try {
      const payload = {
        title: data.title,
        teamId: Number(params.teamId),
        isDraft: !publish,
      };
      
      if (publish) {
        setIsPublishing(true);
      } else {
        dispatch({ type: "setIsCreating", value: true });
      }

      await SurveyService.createSurvey(payload);
      
      if (publish) {
        setIsPublishing(false);
      } else {
        dispatch({ type: "setIsCreating", value: false });
      }

      addToast(
        publish 
          ? "Survey created and published successfully." 
          : "Survey created and saved as draft successfully.",
        {
          appearance: "success",
        }
      );
      
      dispatch({
        type: "setReload",
        value: !reload,
      });
      
      onClose();
    } catch (error) {
      if (publish) {
        setIsPublishing(false);
      } else {
        dispatch({ type: "setIsCreating", value: false });
      }
      addToast("Failed to create survey. Please try again.", {
        appearance: "error",
      });
    }
  };

  return (
    <Modal
      center
      open
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "createTaskModal",
      }}
      showCloseIcon={false}
      onClose={onClose}
    >
      <div className="modal fade popup-modal withcross create-task-popup">
        <h5 className="text-center createTaskHeading">Create New Survey</h5>
        <CustomButton type="button" buttonClass="btnClose">
          <CloseIcon style={{ width: "20px" }} onClick={() => onClose(false)} />
        </CustomButton>

        <div className="">
          <Formik
            initialValues={{ title: "" }}
            validationSchema={surveySchema}
            onSubmit={(values, actions) => {
              // Don't auto-submit, let user choose save or publish
            }}
          >
            {({ values, errors, touched }) => (
              <Form>
                <Field name="title">
                  {({ field, form }) => (
                    <CustomInput
                      inputProps={{
                        placeholder: "Survey Title",
                        value: field.value,
                        name: "title",
                        error:
                          !!form.errors.title && !!form.touched.title
                            ? form.errors.title
                            : null,
                      }}
                      inputClass="form-feild full_w listInput"
                      onChange={field.onChange}
                    />
                  )}
                </Field>

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <CustomButton
                    type="button"
                    buttonClass="btn btn-outline-secondary"
                    onClick={() => submitForm(values, false)}
                    disabled={isCreating || isPublishing || !values.title.trim()}
                  >
                    <FontAwesomeIcon icon={faSave} className="me-2" />
                    {isCreating ? "Saving..." : "Save as Draft"}
                  </CustomButton>
                  <CustomButton
                    type="button"
                    buttonClass="btn btn grad_btn"
                    onClick={() => submitForm(values, true)}
                    disabled={isCreating || isPublishing || !values.title.trim()}
                  >
                    <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                    {isPublishing ? "Publishing..." : "Publish"}
                  </CustomButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};
